export const COMPONENT_NAME = "wallet-withdrawal";
